import { ChangeEvent, ComponentProps, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

interface OnBlurTextInputProps extends Omit<
  ComponentProps<typeof Form.Control>,
  'onChange' | 'onBlur'
> {
  // Called with the typed value on blur, not on every keystroke.
  onChange: (value: string) => void;
}

export const OnBlurTextInput = ({
  onChange,
  value,
  ...formControlPassthroughProps
}: OnBlurTextInputProps) => {
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);
  return (
    <Form.Control
      {...formControlPassthroughProps}
      value={localValue}
      onChange={(e: ChangeEvent<HTMLInputElement>) => setLocalValue(e.currentTarget.value)}
      onBlur={() => {
        onChange(`${localValue ?? ''}`);
        setLocalValue(value);
      }}
    />
  );
};
